import React from 'react';

import style from './index.module.scss';

const ReportRegionInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Отчет по регионам:</h1>
    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис включает в себя:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Отчет позволяет отслеживать количество зарегистрированных предприятий и участий на Секции <br />
          &quot;Закупочные процедуры ПАО &quot;НК &quot;Роснефть&quot; и КИМ
        </div>
      </div>
    </div>
  </>
);

export default ReportRegionInfo;
